import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { StyledIntervals } from './styles/StyledIntervals';


const getTimeWithZero = (data) => {
  if (data < 10) {
    return('0' + data);
  }
  return data;
}


class BtnTimes extends Component {
  render() {
    const { onClickRow, data,} = this.props;

    return (
      <StyledIntervals>
        <button 
          key={data.id}
          aria-label={"Čas rezervace " + getTimeWithZero(new Date(data.time_from).getHours()) + ':' + getTimeWithZero(new Date(data.time_from).getMinutes())}
          className={data.count > 0 ? "free-interval" : "full-interval" }
          onClick={e => onClickRow(data.id, data.count, data.max_count)}
        >
          <span className="time">{getTimeWithZero(new Date(data.time_from).getHours()) + ':' + getTimeWithZero(new Date(data.time_from).getMinutes())}</span>
          <span className="capacity">{data.count + ' / ' + data.max_count}</span>
          <span className="icon"><i className="fa fa-angle-right" aria-hidden="true"></i></span>
        </button>
      </StyledIntervals>
    );
  }
}


BtnTimes.propTypes = {
  data: PropTypes.object.isRequired,
  onClickRow: PropTypes.func.isRequired,
};

export default BtnTimes;



// WEBPACK FOOTER //
// ./src/components/IntervalsContent/BtnTimes.js